WiseMetering.Model.TenantInvoice = WiseMetering.Model.extend({
    urlRoot: '/tenant_invoices',

    site: function() {
        return WiseMetering.zones.get(this.get('site_id'));
    },

    fileLink: function() {
        return this.get('file') ? WiseMetering.apiUrl + this.url() + '/file' : null;
    },

    reGenerate: function() {
        const url = this.url() + '/regenerate';
        return this.save({}, { url });
    },

    icon: function() {
        return 'invoices';
    },

    timezone: function() {
        return this.site() ? this.site().get('timezone') : WiseMetering.currentOrganization.get('timezone');
    }
});
